import React from 'react'
import styled from 'styled-components'

const StyledInput = styled.select`
  width: ${props => props.width};
  height: 40px;
  margin: auto;
  margin-bottom: 30px;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #4466ca;
  outline: none;
  font-family: 'Bellota Text', cursive;
  
  :focus, :hover {
    border-color: #171d45;
  }
`


const SelectInput = (
    {
        name = "",
        content = "",
        onChange = null,
        width = "100%",
        defaultValue,
        className = "",
        children
    }) => {
    return <StyledInput className={className} name={name} onChange={onChange} width={width} value={defaultValue}>{content}{children}</StyledInput>
}

export default SelectInput
